import React from "react";

const LanguageIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={54}
    viewBox="0 0 59 54"
    fill="none"
    {...props}
  >
    <path
      d="M32.01 41.034h19.73m-19.73 0l-5.26 11.124m5.26-11.124l7.88-16.66c.635-1.343.953-2.014 1.387-2.226a1.36 1.36 0 011.196 0c.434.212.752.883 1.387 2.226l7.88 16.66m0 0L57 52.158M2 7.663h16.5m0 0h9.625m-9.625 0V2.102m9.625 5.561H35m-6.875 0c-1.364 8.224-4.53 15.674-9.17 21.926M24 32.691c-1.684-.765-3.403-1.83-5.045-3.102m0 0c-3.72-2.883-7.047-6.835-8.705-10.802m8.705 10.802C14.542 35.536 8.796 40.4 2 43.815"
      stroke="#8065C9"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LanguageIcon;
